export default [
  {
    name: 'invoice-validation',
    path: 'invoice-validation',
    component: () => import('./InvoiceValidation'),
    redirect: { name: 'invoice-validation-queue' },
    meta: { permissions: ['bill_validation_v2'] },
    children: [
      {
        name: 'invoice-validation-queue',
        path: '',
        alias: 'queue',
        component: () => import('./tabs/InvoiceValidationQueue')
      },
      {
        name: 'invoice-validation-list',
        path: 'list',
        component: () => import('./tabs/InvoiceValidationList')
      },
      {
        name: 'invoice-capture-list',
        path: 'invoice-captures',
        component: () => import('./tabs/InvoiceCaptureHistory')
      },
      {
        name: 'invoice-capture-upload',
        path: 'upload',
        component: () => import('./tabs/InvoiceCaptureUpload')
      },
      {
        name: 'invoice-validation-view',
        alias: 'invoice-capture-view',
        path: ':id',
        component: () => import('./tabs/InvoiceValidationView')
      }
    ]
  }
];
